import { Terms as TermsComponent } from '@platform/shared-components'
import { Role, TermType, useGetCurrentTermByRoleAndTypeQuery } from '@platform/data-access'
import { ReactElement, useRef } from 'react'
import {
  WebsiteLayout,
  HEADER_THEMES,
  useCleanHeader,
  useUpdateHeader,
  WebsiteSeo,
} from '@platform/website-components'
import type { GetServerSideProps } from 'next'
import { dehydrate, QueryClient } from '@tanstack/react-query'
import * as Sentry from '@sentry/nextjs'

import styles from './styles.module.scss'

const GET_CURRENT_TERM_BY_ROLE_AND_TYPE_PAYLOAD = {
  input: { role: Role.Global, type: TermType.TermsOfUse },
}

const SEO = {
  title: 'Olby // Terms of use',
}

export const TermsOfUse = () => {
  const contentRef = useRef<HTMLDivElement | null>(null)
  useUpdateHeader(contentRef, HEADER_THEMES.NEUTRAL_BACKGROUND)
  useCleanHeader()
  return (
    <div className={styles['terms-container']} ref={contentRef}>
      <div className={styles['terms-wrapper']}>
        <WebsiteSeo seo={SEO} />
        <TermsComponent type={TermType.TermsOfUse} role={Role.Global} isFetchEnabled={false} />
      </div>
    </div>
  )
}

TermsOfUse.getLayout = (page: ReactElement) => {
  return (
    <WebsiteLayout shouldChangeBgColor headerInitialTheme={HEADER_THEMES.NEUTRAL_BACKGROUND}>
      {page}
    </WebsiteLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async () => {
  try {
    const queryClient = new QueryClient()

    await queryClient.prefetchQuery(
      ['GetCurrentTermByRoleAndType', GET_CURRENT_TERM_BY_ROLE_AND_TYPE_PAYLOAD],
      useGetCurrentTermByRoleAndTypeQuery.fetcher(GET_CURRENT_TERM_BY_ROLE_AND_TYPE_PAYLOAD)
    )
    return {
      props: {
        dehydratedState: dehydrate(queryClient),
      },
    }
  } catch (error) {
    const errorMessage = error as { message: string }
    Sentry.captureMessage(errorMessage.message)
    console.error(error)
    return {
      notFound: true,
    }
  }
}

export default TermsOfUse
